import { StoreType } from '@tock/shared/utils/connect';

/**
 * used in tock api middleware on client and server, ultimately used by ajaxactions
 */
export const getAuthState = (appState: StoreType) => {
  return {
    jwtToken: appState.app.jwtToken,
    sessionToken: appState.app.sessionToken,
    activeAuth: appState.app.activeAuth,
    csrfToken: appState.app.csrfToken,
  };
};
